import { Component, ElementRef, inject } from "@angular/core";
import { IonicModule } from "@ionic/angular";

import { CommonModule, Location } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { Capacitor } from "@capacitor/core";
import { GlobalVarsModel } from "@models/index";
import { TranslateModule } from "@ngx-translate/core";
import { NewBaseService } from "@providers/newBase.service";
import { DeviceService } from "@services/device.service";
import { CASINO_PATHS } from "@shared-constants/routes";
import { Utils } from "@shared-utils/Utils";
import { AnimationOptions, LottieComponent } from "ngx-lottie";

@Component({
  selector: "loading-page",
  templateUrl: "./loading.html",
  styleUrls: ["./loading.scss"],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, TranslateModule, LottieComponent],
})
export class LoadingPage {
  private newBaseService = inject(NewBaseService);
  private deviceService = inject(DeviceService);
  private location = inject(Location);
  private host = inject(ElementRef<HTMLElement>);
  private utils = inject(Utils);

  isCasinoPage = false;
  globalVars!: GlobalVarsModel;
  isDesktop = true;
  isNative = Capacitor.isNativePlatform();
  options: AnimationOptions = {
    path: "assets/global/lottie/codere-loader.json",
  };

  constructor() {
    this.isDesktop = this.deviceService.isDesktop();
    this.newBaseService.getVars.subscribe(async (data) => {
      this.globalVars = data;
      if (this.globalVars.FEATURES.MSO_NewReBranding) {
        this.isCasinoPage = this.location.path().includes(CASINO_PATHS.BASE) || (await this.utils.isCasinoApp());
      }
    });
  }

  ionViewDidLeave() {
    this.host.nativeElement.remove();
  }

  get contentClasses() {
    return {
      backgroundheader: this.globalVars.FEATURES?.MSO_NewReBranding,
      colornewcas: this.globalVars.FEATURES?.MSO_NewReBranding && this.isCasinoPage,
      "dark-background": this.isNative,
    };
  }
}
